var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30009 1.33398H3.03346C2.61795 1.33398 2.21947 1.49904 1.92566 1.79285C1.63186 2.08665 1.4668 2.48514 1.4668 2.90064V15.4339C1.4668 15.8494 1.63186 16.2479 1.92566 16.5417C2.21947 16.8355 2.61795 17.0006 3.03346 17.0006H12.4334C12.8489 17.0006 13.2474 16.8355 13.5412 16.5417C13.835 16.2479 14.0001 15.8494 14.0001 15.4339V6.03396L9.30009 1.33398Z",
    stroke: "#FFC97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29883 1.33398V6.03396H13.9988",
    stroke: "#FFC97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8662 9.9502H4.59961",
    stroke: "#FFC97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8662 13.084H4.59961",
    stroke: "#FFC97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16627 6.81738H5.38294H4.59961",
    stroke: "#FFC97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.3bc6e4ecdf95e10371949b7960bd5054.svg";
export { ForwardRef as ReactComponent };